const getMe = (state) => state.me;
const isPrime = (state) => state.me.account_type === "prime";
const getSchedulingSettings = (state) => state.scheduling.settings;
const getSchedulingAvailability = (state) => state.scheduling.availability;
const getSchedulingEvents = (state) => state.scheduling.events;
const getSchedulingEmbeds = (state) => state.scheduling.embeds;
const getSchedulingPendings = (state) => state.scheduling.pendings;
const getSchedulingPolls = (state) => state.scheduling.polls;
const getIntegrations = (state) => state.integrations;
const getInvitations = (state) => state.invitations;

const isLimitedEvent = (state) => {
  let max_event = state.me.event_numbers;

  if (max_event == null) return false;

  let events = state.scheduling.events.length + state.scheduling.embeds.length + state.scheduling.pendings.length;

  return max_event - events <= 0;
};

const getOrganization = (state) => state.organization;
const getRequests = (state) => state.requests;
const canUpgrade = (state) => {
  let data = true;
  if (state.organization) {
    let me = state.organization.members.find((m) => m.member_id == state.me.userID);
    if (me && me.role != "owner") {
      data = false;
    }
  }
  return data;
};

const getCname = (state) => {
  if (state.me && state.me.custom_domain) {
    let domain = state.me.custom_domain;
    if (!domain.startsWith("http")) {
      if (domain.startsWith("localhost")) domain = "http://" + domain;
      else domain = "https://" + domain;
    }
    return domain;
  } else return null;
};

const getDomain = (state) => {
  if (state.me && state.me.custom_domain) {
    let domain = state.me.custom_domain;
    if (!domain.startsWith("http")) {
      if (domain.startsWith("localhost")) domain = "http://" + domain;
      else domain = "https://" + domain;
    }
    return domain;
  } else return location.origin;
};

const getExternalLink = (state) => {
  if (state.me && state.me.custom_domain) {
    let domain = state.me.custom_domain;
    if (!domain.startsWith("http")) {
      if (domain.startsWith("localhost")) domain = "http://" + domain;
      else domain = "https://" + domain;
    }
    return domain;
  } else {
    let link = process.env.VUE_APP_EXTERNAL_LINK;
    if (link != "https://weezly.com") link = location.origin;
    return link;
  }
};

export default {
  getMe,
  isPrime,
  getSchedulingSettings,
  getSchedulingAvailability,
  getSchedulingEvents,
  getSchedulingEmbeds,
  getSchedulingPendings,
  getSchedulingPolls,
  getIntegrations,
  getInvitations,
  isLimitedEvent,
  getOrganization,
  getRequests,
  canUpgrade,
  getCname,
  getDomain,
  getExternalLink,
};
